import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const SBM_InitialPsychiatricEvaluation = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='SBM_InitialPsychiatricEvaluation' className='file-pdf-document'>
            <div className='file-template'>


                <h3>SEEDLINKS</h3>
                <h3>INITIAL PSYCHIATRIC EVALUATION</h3>
                <p>
                    <span className='eleHeader'>ALLERGIES:</span>
                    <textarea id="txtAllergies" name="txtAllergies" className='add-only' ></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Age:</span></td>
                        <td className='w-187'><span className='eleHeader'>Height:</span></td>
                        <td className='w-187'><span className='eleHeader'>Weight:</span></td>
                        <td className='w-187'><span className='eleHeader'>Up or Down:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="text" id="txtAge" name="txtAge" className='add-only' /> </td>
                        <td className='w-187'>
                            <input placeholder="Inches" type="text" id="txtHeight" name="txtHeight" className='add-only' /> </td>
                        <td className='w-187'>
                            <input placeholder="#" type="text" id="txtWeight" name="txtWeight" className='add-only' /> </td>
                        <td className='w-187'>
                            <input placeholder="#" type="text" id="txtUpDown" name="txtUpDown" className='add-only' /> </td>
                    </tr> 
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Since</span></td>
                        <td className='w-187'><span className='eleHeader'>Body Mass Index:</span></td>
                        <td className='w-187'><span className='eleHeader'>Blood Pressure:</span></td>
                        <td className='w-187'><span className='eleHeader'>Pulse:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="text" id="txtSince" name="txtSince" className='add-only' /> </td>
                        <td className='w-187'>
                            <input type="text" id="txtBodyMassIndex" name="txtBodyMassIndex" className='add-only' /> </td>
                        <td className='w-187'>
                            <input type="text" id="txtBloodPressure" name="txtBloodPressure" className='add-only' /> </td>
                        <td className='w-187'>
                            <input type="text" id="txtPulse" name="txtPulse" className='add-only' /> </td>
                    </tr> 
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Temp:</span></td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="text" id="txtTemp" name="txtTemp" className='add-only' /> </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table> 
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Diagnosis:</span></td>
                        <td className='w-375'><span className='eleHeader'>Current Medications::</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="text" id="txtDiagnosis_1" name="txtDiagnosis_1" className='add-only' /> </td>
                        <td className='w-375'><input type="text" id="txtCurrMedic_1" name="txtCurrMedic_1" className='add-only' /> </td>
                    </tr>
                    <tr> 
                        <td className='w-375'><input type="text" id="txtDiagnosis_2" name="txtDiagnosis_2" className='add-only' /> </td>
                        <td className='w-375'><input type="text" id="txtCurrMedic_2" name="txtCurrMedic_2" className='add-only' /> </td>
                    </tr>
                    <tr> 
                        <td className='w-375'><input type="text" id="txtDiagnosis_3" name="txtDiagnosis_3" className='add-only' /> </td>
                        <td className='w-375'><input type="text" id="txtCurrMedic_3" name="txtCurrMedic_3" className='add-only' /> </td>
                    </tr>
                    <tr> 
                        <td className='w-375'><input type="text" id="txtDiagnosis_4" name="txtDiagnosis_4" className='add-only' /> </td>
                        <td className='w-375'><input type="text" id="txtCurrMedic_4" name="txtCurrMedic_4" className='add-only' /> </td>
                    </tr>
                    <tr> 
                        <td className='w-375'><input type="text" id="txtDiagnosis_5" name="txtDiagnosis_5" className='add-only' /> </td>
                        <td className='w-375'><input type="text" id="txtCurrMedic_5" name="txtCurrMedic_5" className='add-only' /> </td>
                    </tr>
                    <tr> 
                        <td className='w-375'><input type="text" id="txtDiagnosis_6" name="txtDiagnosis_6" className='add-only' /> </td>
                        <td className='w-375'><input type="text" id="txtCurrMedic_6" name="txtCurrMedic_6" className='add-only' /> </td>
                    </tr>
                    <tr> 
                        <td className='w-375'><input type="text" id="txtDiagnosis_7" name="txtDiagnosis_7" className='add-only' /> </td>
                        <td className='w-375'><input type="text" id="txtCurrMedic_7" name="txtCurrMedic_7" className='add-only' /> </td>
                    </tr>
                    <tr> 
                        <td className='w-375'><input type="text" id="txtDiagnosis_8" name="txtDiagnosis_8" className='add-only' /> </td>
                        <td className='w-375'><input type="text" id="txtCurrMedic_8" name="txtCurrMedic_8" className='add-only' /> </td>
                    </tr>
                    <tr> 
                        <td className='w-375'><input type="text" id="txtDiagnosis_9" name="txtDiagnosis_9" className='add-only' /> </td>
                        <td className='w-375'><input type="text" id="txtCurrMedic_9" name="txtCurrMedic_9" className='add-only' /> </td>
                    </tr>
                    <tr> 
                        <td className='w-375'><input type="text" id="txtDiagnosis_10" name="txtDiagnosis_10" className='add-only' /> </td>
                        <td className='w-375'><input type="text" id="txtCurrMedic_10" name="txtCurrMedic_10" className='add-only' /> </td>
                    </tr>  
                </table>



                <p>
                    <span className='eleHeader'>Compliant on Medications?</span>
                    <input type="radio" id="rbCompliantMedications_Yes" name="rbCompliantMedications" className='add-only' value="Yes" />  Yes &nbsp;
                    <input type="radio" id="rbCompliantMedications_No" name="rbCompliantMedications" className='add-only' value="No" />  No&nbsp;
                </p>
                <p>
                    <span className='eleHeader'>Possible Side Effects?</span>
                    <input type="radio" id="rbPossibleSideEffects_Yes" name="rbPossibleSideEffects" className='add-only' value="Yes" />  Yes &nbsp;
                    <input type="radio" id="rbPossibleSideEffects_No" name="rbPossibleSideEffects" className='add-only' value="No" />  No&nbsp;
                </p>
                <p>
                    <span className='eleHeader'>Labs / Medical Studies / Rating Scales:</span>
                    <textarea id="txtLabsMedicalStudiesRatingScales" name="txtLabsMedicalStudiesRatingScales" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Chief Complaint / History of Present Illness:</span>
                    <textarea id="txtChiefComplaint" name="txtChiefComplaint" className='add-only' ></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Suicidal?</span>
                    <input type="radio" id="rbSuicidal_No" name="rbSuicidal" className='add-only' value="No" />  No &nbsp;
                    <input type="radio" id="rbSuicidal_Yes" name="rbSuicidal" className='add-only' value="Yes" />  Yes &nbsp; (Plans?)

                    <textarea id="txtSuicidalPlans" name="txtSuicidalPlans" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Homicidal?</span>
                    <input type="radio" id="rbHomicidal_No" name="rbHomicidal" className='add-only' value="No" />  No&nbsp;
                    <input type="radio" id="rbHomicidal_Yes" name="rbHomicidal" className='add-only' value="Yes" />  Yes &nbsp; (Plans?)

                    <textarea id="txtHomicidalPlans" name="txtHomicidalPlans" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Hallucinations / Delusions?</span>
                    <input type="radio" id="rbHallucinationsDelusions_No" name="rbHallucinationsDelusions" className='add-only' value="No" />  No&nbsp;
                    <input type="radio" id="rbHallucinationsDelusions_Yes" name="rbHallucinationsDelusions" className='add-only' value="Yes" />  Yes &nbsp;
                </p>

                <p>
                    <span className='eleHeader'>Abuse History?</span>
                    <input type="radio" id="rbAbuseHistory_Denies" name="rbAbuseHistory" className='add-only' value="Denies" /> Denies &nbsp;
                    <input type="radio" id="rbAbuseHistory_Physical" name="rbAbuseHistory" className='add-only' value="Physical" /> Physical &nbsp;
                    <input type="radio" id="rbAbuseHistory_Sexual" name="rbAbuseHistory" className='add-only' value="Sexual" /> Sexual &nbsp;
                    <input type="radio" id="rbAbuseHistory_Psychological" name="rbAbuseHistory" className='add-only' value="Psychological" /> Psychological / Emotional &nbsp;
                    <input type="radio" id="rbAbuseHistory_Neglect" name="rbAbuseHistory" className='add-only' value="Neglect" /> Neglect
                </p>
                <p>
                    <span className='eleHeader'>Alcohol / Drugs / Cigs?</span>
                    <input type="radio" id="rbAlcoholDrugsCigs_No" name="rbAlcoholDrugsCigs" className='add-only' value="No" />  No&nbsp;
                    <input type="radio" id="rbAlcoholDrugsCigs_Yes" name="rbAlcoholDrugsCigs" className='add-only' value="Yes" />  Yes &nbsp;
                </p>


                <p>
                    <span className='eleHeader'>Mood?</span>
                    Depressed &nbsp;
                    <input type="radio" id="rbMood_0" name="rbMood" className='add-only' value="Mood_0" />  &nbsp;
                    0 &nbsp;
                    <input type="radio" id="rbMood_1" name="rbMood" className='add-only' value="Mood_1" />  &nbsp;
                    1 &nbsp;
                    <input type="radio" id="rbMood_2" name="rbMood" className='add-only' value="Mood_2" />  &nbsp;
                    2 &nbsp;
                    <input type="radio" id="rbMood_3" name="rbMood" className='add-only' value="Mood_3" />  &nbsp;
                    3 &nbsp;
                    <input type="radio" id="rbMood_4" name="rbMood" className='add-only' value="Mood_4" />  &nbsp;
                    4 &nbsp;
                    <input type="radio" id="rbMood_5" name="rbMood" className='add-only' value="Mood_5" />  &nbsp;
                    5 &nbsp;
                    <input type="radio" id="rbMood_6" name="rbMood" className='add-only' value="Mood_6" />  &nbsp;
                    6 &nbsp;
                    <input type="radio" id="rbMood_7" name="rbMood" className='add-only' value="Mood_7" />  &nbsp;
                    7 &nbsp;
                    <input type="radio" id="rbMood_8" name="rbMood" className='add-only' value="Mood_8" />  &nbsp;
                    8 &nbsp;
                    <input type="radio" id="rbMood_9" name="rbMood" className='add-only' value="Mood_9" />  &nbsp;
                    9 &nbsp;
                    <input type="radio" id="rbMood_10" name="rbMood" className='add-only' value="Mood_10" />  &nbsp;
                    10 &nbsp;
                    Happy (?Mania)
                    <textarea id="txtMoodMania" name="txtMoodMania" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Anxiety Level?</span>
                    Low &nbsp;
                    <input type="radio" id="rbAnxietyLevel_0" name="rbAnxietyLevel" className='add-only' value="AnxietyLevel_0" />  &nbsp;
                    0 &nbsp;
                    <input type="radio" id="rbAnxietyLevel_1" name="rbAnxietyLevel" className='add-only' value="AnxietyLevel_1" />  &nbsp;
                    1 &nbsp;
                    <input type="radio" id="rbAnxietyLevel_2" name="rbAnxietyLevel" className='add-only' value="AnxietyLevel_2" />  &nbsp;
                    2 &nbsp;
                    <input type="radio" id="rbAnxietyLevel_3" name="rbAnxietyLevel" className='add-only' value="AnxietyLevel_3" />  &nbsp;
                    3 &nbsp;
                    <input type="radio" id="rbAnxietyLevel_4" name="rbAnxietyLevel" className='add-only' value="AnxietyLevel_4" />  &nbsp;
                    4 &nbsp;
                    <input type="radio" id="rbAnxietyLevel_5" name="rbAnxietyLevel" className='add-only' value="AnxietyLevel_5" />  &nbsp;
                    5 &nbsp;
                    <input type="radio" id="rbAnxietyLevel_6" name="rbAnxietyLevel" className='add-only' value="AnxietyLevel_6" />  &nbsp;
                    6 &nbsp;
                    <input type="radio" id="rbAnxietyLevel_7" name="rbAnxietyLevel" className='add-only' value="AnxietyLevel_7" />  &nbsp;
                    7 &nbsp;
                    <input type="radio" id="rbAnxietyLevel_8" name="rbAnxietyLevel" className='add-only' value="AnxietyLevel_8" />  &nbsp;
                    8 &nbsp;
                    <input type="radio" id="rbAnxietyLevel_9" name="rbAnxietyLevel" className='add-only' value="AnxietyLevel_9" />  &nbsp;
                    9 &nbsp;
                    <input type="radio" id="rbAnxietyLevel_10" name="rbAnxietyLevel" className='add-only' value="AnxietyLevel_10" />  &nbsp;
                    10 &nbsp;
                    High
                    <textarea id="txtAnxietyLevel" name="txtAnxietyLevel" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Sleep?</span>
                    <input type="radio" id="rbSleep_Normal" name="rbSleep" className='add-only' value="Normal" /> Normal &nbsp;
                    <input type="radio" id="rbSleep_Increased" name="rbSleep" className='add-only' value="Increased" /> Increased &nbsp;
                    <input type="radio" id="rbSleep_Decreased" name="rbSleep" className='add-only' value="Decreased" /> Decreased &nbsp;
                    <input type="radio" id="rbSleep_Nightmares" name="rbSleep" className='add-only' value="Nightmares" /> Nightmares
                    <textarea id="txtSleep" name="txtSleep" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Energy Level?</span>
                    Low &nbsp;
                    <input type="radio" id="rbEnergyLevel_0" name="rbEnergyLevel" className='add-only' value="EnergyLevel_0" />  0 &nbsp;
                    <input type="radio" id="rbEnergyLevel_1" name="rbEnergyLevel" className='add-only' value="EnergyLevel_1" />  1 &nbsp;
                    <input type="radio" id="rbEnergyLevel_2" name="rbEnergyLevel" className='add-only' value="EnergyLevel_2" />  2 &nbsp;
                    <input type="radio" id="rbEnergyLevel_3" name="rbEnergyLevel" className='add-only' value="EnergyLevel_3" />  3 &nbsp;
                    <input type="radio" id="rbEnergyLevel_4" name="rbEnergyLevel" className='add-only' value="EnergyLevel_4" />  4 &nbsp;
                    <input type="radio" id="rbEnergyLevel_5" name="rbEnergyLevel" className='add-only' value="EnergyLevel_5" />  5 &nbsp;
                    <input type="radio" id="rbEnergyLevel_6" name="rbEnergyLevel" className='add-only' value="EnergyLevel_6" />  6 &nbsp;
                    <input type="radio" id="rbEnergyLevel_7" name="rbEnergyLevel" className='add-only' value="EnergyLevel_7" />  7 &nbsp;
                    <input type="radio" id="rbEnergyLevel_8" name="rbEnergyLevel" className='add-only' value="EnergyLevel_8" />  8 &nbsp;
                    <input type="radio" id="rbEnergyLevel_9" name="rbEnergyLevel" className='add-only' value="EnergyLevel_9" />  9 &nbsp;
                    <input type="radio" id="rbEnergyLevel_10" name="rbEnergyLevel" className='add-only' value="EnergyLevel_10" />  10
                    High
                </p>
                <p>

                    <input type="radio" id="rbEnergyLevel_Increased" name="rbEnergyLevel" className='add-only' value="Increased" /> Increased &nbsp;
                    <input type="radio" id="rbEnergyLevel_Decreased" name="rbEnergyLevel" className='add-only' value="Decreased" /> Decreased
                    <textarea id="txtEnergyLevel" name="txtEnergyLevel" className='add-only' ></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Appetite / Weight?:</span>
                    <input type="radio" id="rbAppetiteWeight_NoRecentChange" name="rbAppetiteWeight" className='add-only' value="NoRecentChange" /> No Recent Change &nbsp;
                    <input type="radio" id="rbAppetiteWeight_Increased" name="rbAppetiteWeight" className='add-only' value="Increased" /> Increased &nbsp;
                    <input type="radio" id="rbAppetiteWeight_Decreased" name="rbAppetiteWeight" className='add-only' value="Decreased" /> Decreased

                </p>
                <p>
                    Any Weight Change?
                    <textarea id="txtAppetiteWeightAnyWeightChange" name="txtAppetiteWeightAnyWeightChange" className='add-only' ></textarea>

                </p>


                <p>
                    <span className='eleHeader'>Attention Span?</span>
                    Poor &nbsp;
                    <input type="radio" id="rbAttentionSpan_0" name="rbAttentionSpan" className='add-only' value="AttentionSpan_0" />  0 &nbsp;
                    <input type="radio" id="rbAttentionSpan_1" name="rbAttentionSpan" className='add-only' value="AttentionSpan_1" />  1 &nbsp;
                    <input type="radio" id="rbAttentionSpan_2" name="rbAttentionSpan" className='add-only' value="AttentionSpan_2" />  2 &nbsp;
                    <input type="radio" id="rbAttentionSpan_3" name="rbAttentionSpan" className='add-only' value="AttentionSpan_3" />  3 &nbsp;
                    <input type="radio" id="rbAttentionSpan_4" name="rbAttentionSpan" className='add-only' value="AttentionSpan_4" />  4 &nbsp;
                    <input type="radio" id="rbAttentionSpan_5" name="rbAttentionSpan" className='add-only' value="AttentionSpan_5" />  5 &nbsp;
                    <input type="radio" id="rbAttentionSpan_6" name="rbAttentionSpan" className='add-only' value="AttentionSpan_6" />  6 &nbsp;
                    <input type="radio" id="rbAttentionSpan_7" name="rbAttentionSpan" className='add-only' value="AttentionSpan_7" />  7 &nbsp;
                    <input type="radio" id="rbAttentionSpan_8" name="rbAttentionSpan" className='add-only' value="AttentionSpan_8" />  8 &nbsp;
                    <input type="radio" id="rbAttentionSpan_9" name="rbAttentionSpan" className='add-only' value="AttentionSpan_9" />  9 &nbsp;
                    <input type="radio" id="rbAttentionSpan_10" name="rbAttentionSpan" className='add-only' value="AttentionSpan_10" />  10
                    Good
                </p>
                <p>
                    <span className='eleHeader'>Impulse Control?</span>
                    Poor &nbsp;
                    <input type="radio" id="rbImpulseControl_0" name="rbImpulseControl" className='add-only' value="ImpulseControl_0" />  0 &nbsp;
                    <input type="radio" id="rbImpulseControl_1" name="rbImpulseControl" className='add-only' value="ImpulseControl_1" />  1 &nbsp;
                    <input type="radio" id="rbImpulseControl_2" name="rbImpulseControl" className='add-only' value="ImpulseControl_2" />  2 &nbsp;
                    <input type="radio" id="rbImpulseControl_3" name="rbImpulseControl" className='add-only' value="ImpulseControl_3" />  3 &nbsp;
                    <input type="radio" id="rbImpulseControl_4" name="rbImpulseControl" className='add-only' value="ImpulseControl_4" />  4 &nbsp;
                    <input type="radio" id="rbImpulseControl_5" name="rbImpulseControl" className='add-only' value="ImpulseControl_5" />  5 &nbsp;
                    <input type="radio" id="rbImpulseControl_6" name="rbImpulseControl" className='add-only' value="ImpulseControl_6" />  6 &nbsp;
                    <input type="radio" id="rbImpulseControl_7" name="rbImpulseControl" className='add-only' value="ImpulseControl_7" />  7 &nbsp;
                    <input type="radio" id="rbImpulseControl_8" name="rbImpulseControl" className='add-only' value="ImpulseControl_8" />  8 &nbsp;
                    <input type="radio" id="rbImpulseControl_9" name="rbImpulseControl" className='add-only' value="ImpulseControl_9" />  9 &nbsp;
                    <input type="radio" id="rbImpulseControl_10" name="rbImpulseControl" className='add-only' value="ImpulseControl_10" />  10
                    Good

                    <textarea id="txtImpulseControl" name="txtImpulseControl" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>School / Home / Work Issues:</span>
                    <input type="checkbox" id="cbSchoolHomeWorkIssues" name="cbSchoolHomeWorkIssues" className='add-only' value="SchoolHomeWorkIssues" /> No Recent Change
                </p>
                <p>
                    Worse &nbsp;
                    <input type="radio" id="rbSchoolHomeWorkIssues_0" name="rbSchoolHomeWorkIssues" className='add-only' value="SchoolHomeWorkIssues_0" />  0 &nbsp;
                    <input type="radio" id="rbSchoolHomeWorkIssues_1" name="rbSchoolHomeWorkIssues" className='add-only' value="SchoolHomeWorkIssues_1" />  1 &nbsp;
                    <input type="radio" id="rbSchoolHomeWorkIssues_2" name="rbSchoolHomeWorkIssues" className='add-only' value="SchoolHomeWorkIssues_2" />  2 &nbsp;
                    <input type="radio" id="rbSchoolHomeWorkIssues_3" name="rbSchoolHomeWorkIssues" className='add-only' value="SchoolHomeWorkIssues_3" />  3 &nbsp;
                    <input type="radio" id="rbSchoolHomeWorkIssues_4" name="rbSchoolHomeWorkIssues" className='add-only' value="SchoolHomeWorkIssues_4" />  4 &nbsp;
                    <input type="radio" id="rbSchoolHomeWorkIssues_5" name="rbSchoolHomeWorkIssues" className='add-only' value="SchoolHomeWorkIssues_5" />  5 &nbsp;
                    <input type="radio" id="rbSchoolHomeWorkIssues_6" name="rbSchoolHomeWorkIssues" className='add-only' value="SchoolHomeWorkIssues_6" />  6 &nbsp;
                    <input type="radio" id="rbSchoolHomeWorkIssues_7" name="rbSchoolHomeWorkIssues" className='add-only' value="SchoolHomeWorkIssues_7" />  7 &nbsp;
                    <input type="radio" id="rbSchoolHomeWorkIssues_8" name="rbSchoolHomeWorkIssues" className='add-only' value="SchoolHomeWorkIssues_8" />  8 &nbsp;
                    <input type="radio" id="rbSchoolHomeWorkIssues_9" name="rbSchoolHomeWorkIssues" className='add-only' value="SchoolHomeWorkIssues_9" />  9 &nbsp;
                    <input type="radio" id="rbSchoolHomeWorkIssues_10" name="rbSchoolHomeWorkIssues" className='add-only' value="SchoolHomeWorkIssues_10" />  10
                    Better

                    <textarea id="txtSchoolHomeWorkIssues" name="txtSchoolHomeWorkIssues" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Past Psychiatric History:</span>
                    <textarea id="txtPastPsychiatricHistory" name="txtPastPsychiatricHistory" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Medical History:</span>
                    <textarea id="txtMedicalHistory" name="txtMedicalHistory" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Family / Social History:</span>
                    <textarea id="txtFamilySocialHistory" name="txtFamilySocialHistory" className='add-only' ></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Patient Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>DOB:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtPatientName" name="txtPatientName" className='add-only' /> </td>
                        <td className='w-375'>
                            <input type="date" id="txtPatientDob" name="txtPatientDob" className='add-only' /> </td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>Mental Status Examination:</span>
                    <textarea id="txtMentalStatusExamination" name="txtMentalStatusExamination" className='add-only' ></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Appearance / Dress:</span>
                    <input type="checkbox" id="cbAppearance_1" name="cbAppearance_1" className='add-only' value="Appearance_1" /> yo &nbsp;
                    <input type="checkbox" id="cbAppearance_2" name="cbAppearance_2" className='add-only' value="Appearance_2" /> Race &nbsp;
                    <input type="checkbox" id="cbAppearance_3" name="cbAppearance_3" className='add-only' value="Appearance_3" /> Male &nbsp;
                    <input type="checkbox" id="cbAppearance_4" name="cbAppearance_4" className='add-only' value="Appearance_4" /> Female &nbsp;
                    <input type="checkbox" id="cbAppearance_5" name="cbAppearance_5" className='add-only' value="Appearance_5" /> Casual &nbsp;
                    <input type="checkbox" id="cbAppearance_6" name="cbAppearance_6" className='add-only' value="Appearance_6" /> Neat &nbsp;
                    <input type="checkbox" id="cbAppearance_7" name="cbAppearance_7" className='add-only' value="Appearance_7" /> Unkempt

                    <textarea id="txtMentalStatusAppearance" name="txtMentalStatusAppearance" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Behavior / Attitude:</span>
                    <input type="checkbox" id="cbBehavior_1" name="cbBehavior_1" className='add-only' value="Behavior_1" /> Cooperative &nbsp;
                    <input type="checkbox" id="cbBehavior_2" name="cbBehavior_2" className='add-only' value="Behavior_2" /> Guarded &nbsp;
                    <input type="checkbox" id="cbBehavior_3" name="cbBehavior_3" className='add-only' value="Behavior_3" /> Defiant &nbsp;
                    <input type="checkbox" id="cbBehavior_4" name="cbBehavior_4" className='add-only' value="Behavior_4" /> Fearful

                    <textarea id="txtMentalStatusBehavior" name="txtMentalStatusBehavior" className='add-only' ></textarea>
                </p>


                <p>
                    <span className='eleHeader'>Suicidal?</span>
                    <input type="radio" id="rbMentalStatusSuicidal_No" name="rbMentalStatusSuicidal" className='add-only' value="No" />  No&nbsp;
                    <input type="radio" id="rbMentalStatusSuicidal_Yes" name="rbMentalStatusSuicidal" className='add-only' value="Yes" />  Yes &nbsp; (Plans?)

                    <textarea id="txtMentalStatusSuicidalPlans" name="txtMentalStatusSuicidalPlans" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Homicidal?</span>
                    <input type="radio" id="rbMentalStatusHomicidal_No" name="rbMentalStatusHomicidal" className='add-only' value="No" />  No&nbsp;
                    <input type="radio" id="rbMentalStatusHomicidal_Yes" name="rbMentalStatusHomicidal" className='add-only' value="Yes" />  Yes &nbsp; (Plans?)

                    <textarea id="txtMentalStatusHomicidalPlans" name="txtMentalStatusHomicidalPlans" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Hallucinations / Delusions?</span>
                    <input type="radio" id="rbMentalStatusHallucinationsDelusions_No" name="rbMentalStatusHallucinationsDelusions" className='add-only' value="No" />  No &nbsp;
                    <input type="radio" id="rbMentalStatusHallucinationsDelusions_Auditory" name="rbMentalStatusHallucinationsDelusions" className='add-only' value="Auditory" /> Auditory &nbsp;
                    <input type="radio" id="rbMentalStatusHallucinationsDelusions_Visual" name="rbMentalStatusHallucinationsDelusions" className='add-only' value="Visual" /> Visual &nbsp;
                    <input type="radio" id="rbMentalStatusHallucinationsDelusions_Paranoia" name="rbMentalStatusHallucinationsDelusions" className='add-only' value="Paranoia" /> Paranoia &nbsp;

                    <textarea id="txtMentalStatusHallucinations" name="txtMentalStatusHallucinations" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Mood?</span>
                    Depressed &nbsp;
                    <input type="radio" id="rbMentalStatusMood_0" name="rbMentalStatusMood" className='add-only' value="MentalStatusMood_0" />  0 &nbsp;
                    <input type="radio" id="rbMentalStatusMood_1" name="rbMentalStatusMood" className='add-only' value="MentalStatusMood_1" />  1 &nbsp;
                    <input type="radio" id="rbMentalStatusMood_2" name="rbMentalStatusMood" className='add-only' value="MentalStatusMood_2" />  2 &nbsp;
                    <input type="radio" id="rbMentalStatusMood_3" name="rbMentalStatusMood" className='add-only' value="MentalStatusMood_3" />  3 &nbsp;
                    <input type="radio" id="rbMentalStatusMood_4" name="rbMentalStatusMood" className='add-only' value="MentalStatusMood_4" />  4 &nbsp;
                    <input type="radio" id="rbMentalStatusMood_5" name="rbMentalStatusMood" className='add-only' value="MentalStatusMood_5" />  5 &nbsp;
                    <input type="radio" id="rbMentalStatusMood_6" name="rbMentalStatusMood" className='add-only' value="MentalStatusMood_6" />  6 &nbsp;
                    <input type="radio" id="rbMentalStatusMood_7" name="rbMentalStatusMood" className='add-only' value="MentalStatusMood_7" />  7 &nbsp;
                    <input type="radio" id="rbMentalStatusMood_8" name="rbMentalStatusMood" className='add-only' value="MentalStatusMood_8" />  8 &nbsp;
                    <input type="radio" id="rbMentalStatusMood_9" name="rbMentalStatusMood" className='add-only' value="MentalStatusMood_9" />  9 &nbsp;
                    <input type="radio" id="rbMentalStatusMood_10" name="rbMentalStatusMood" className='add-only' value="MentalStatusMood_10" />  10
                    Happy
                </p>
                <p>
                    <input type="checkbox" id="cbMentalStatusMood_Irritable" name="cbMentalStatusMood_Irritable" className='add-only' value="MentalStatusMood_Irritable" /> Irritable &nbsp;
                    <input type="checkbox" id="cbMentalStatusMood_Anxious" name="cbMentalStatusMood_Anxious" className='add-only' value="MentalStatusMood_Anxious" /> Anxious &nbsp;
                    <input type="checkbox" id="cbMentalStatusMood_Guilty" name="cbMentalStatusMood_Guilty" className='add-only' value="MentalStatusMood_Guilty" /> Guilty &nbsp;
                    <input type="checkbox" id="cbMentalStatusMood_Ashamed" name="cbMentalStatusMood_Ashamed" className='add-only' value="MentalStatusMood_Ashamed" /> Ashamed &nbsp;
                    <input type="checkbox" id="cbMentalStatusMood_Manic" name="cbMentalStatusMood_Manic" className='add-only' value="MentalStatusMood_Manic" /> Manic

                    <textarea id="txtMentalStatusMoodMania" name="txtMentalStatusMoodMania" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Affect?</span>
                    <input type="checkbox" id="cbMentalStatusAffect_MoodCongruent" name="cbMentalStatusAffect_MoodCongruent" className='add-only' value="MentalStatusAffect_MoodCongruent" /> Mood Congruent &nbsp;
                    <input type="checkbox" id="cbMentalStatusAffect_Sad" name="cbMentalStatusAffect_Sad" className='add-only' value="MentalStatusAffect_Sad" /> Sad &nbsp;
                    <input type="checkbox" id="cbMentalStatusAffect_Angry" name="cbMentalStatusAffect_Angry" className='add-only' value="MentalStatusAffect_Angry" /> Angry &nbsp;
                    <input type="checkbox" id="cbMentalStatusAffect_Guarded" name="cbMentalStatusAffect_Guarded" className='add-only' value="MentalStatusAffect_Guarded" /> Guarded &nbsp;
                    <input type="checkbox" id="cbMentalStatusAffect_Blunted" name="cbMentalStatusAffect_Blunted" className='add-only' value="MentalStatusAffect_Blunted" /> Blunted &nbsp;
                    <input type="checkbox" id="cbMentalStatusAffect_Happy" name="cbMentalStatusAffect_Happy" className='add-only' value="MentalStatusAffect_Happy" /> Happy


                    <textarea id="txtMentalStatusAffect" name="txtMentalStatusAffect" className='add-only' ></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Energy Level?</span>
                    Low
                    <input type="radio" id="rbMentalStatusEnergyLevel_0" name="rbMentalStatusEnergyLevel" className='add-only' value="MentalStatusEnergyLevel_0" />  0 &nbsp;
                    <input type="radio" id="rbMentalStatusEnergyLevel_1" name="rbMentalStatusEnergyLevel" className='add-only' value="MentalStatusEnergyLevel_1" />  1 &nbsp;
                    <input type="radio" id="rbMentalStatusEnergyLevel_2" name="rbMentalStatusEnergyLevel" className='add-only' value="MentalStatusEnergyLevel_2" />  2 &nbsp;
                    <input type="radio" id="rbMentalStatusEnergyLevel_3" name="rbMentalStatusEnergyLevel" className='add-only' value="MentalStatusEnergyLevel_3" />  3 &nbsp;
                    <input type="radio" id="rbMentalStatusEnergyLevel_4" name="rbMentalStatusEnergyLevel" className='add-only' value="MentalStatusEnergyLevel_4" />  4 &nbsp;
                    <input type="radio" id="rbMentalStatusEnergyLevel_5" name="rbMentalStatusEnergyLevel" className='add-only' value="MentalStatusEnergyLevel_5" />  5 &nbsp;
                    <input type="radio" id="rbMentalStatusEnergyLevel_6" name="rbMentalStatusEnergyLevel" className='add-only' value="MentalStatusEnergyLevel_6" />  6 &nbsp;
                    <input type="radio" id="rbMentalStatusEnergyLevel_7" name="rbMentalStatusEnergyLevel" className='add-only' value="MentalStatusEnergyLevel_7" />  7 &nbsp;
                    <input type="radio" id="rbMentalStatusEnergyLevel_8" name="rbMentalStatusEnergyLevel" className='add-only' value="MentalStatusEnergyLevel_8" />  8 &nbsp;
                    <input type="radio" id="rbMentalStatusEnergyLevel_9" name="rbMentalStatusEnergyLevel" className='add-only' value="MentalStatusEnergyLevel_9" />  9 &nbsp;
                    <input type="radio" id="rbMentalStatusEnergyLevel_10" name="rbMentalStatusEnergyLevel" className='add-only' value="MentalStatusEnergyLevel_10" />  10
                    High
                </p>
                <p>

                    <input type="checkbox" id="cbMentalStatusEnergyLevel_Normal" name="cbMentalStatusEnergyLevel_Normal" className='add-only' value="MentalStatusEnergyLevel_Normal" /> Normal &nbsp;
                    <input type="checkbox" id="cbMentalStatusEnergyLevel_Overactive" name="cbMentalStatusEnergyLevel_Overactive" className='add-only' value="MentalStatusEnergyLevel_Overactive" /> Overactive &nbsp;
                    <input type="checkbox" id="cbMentalStatusEnergyLevel_Underactive" name="cbMentalStatusEnergyLevel_Underactive" className='add-only' value="MentalStatusEnergyLevel_Underactive" /> Underactive &nbsp;
                    <textarea id="txtMentalStatusEnergyLevel" name="txtMentalStatusEnergyLevel" className='add-only' ></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Speech?</span>


                    <input type="checkbox" id="cbMentalStatusSpeech_Normal" name="cbMentalStatusSpeech_Normal" className='add-only' value="MentalStatusSpeech_Normal" /> Normal &nbsp;
                    <input type="checkbox" id="cbMentalStatusSpeech_Overproductive" name="cbMentalStatusSpeech_Overproductive" className='add-only' value="MentalStatusSpeech_Overproductive" /> Overproductive &nbsp;
                    <input type="checkbox" id="cbMentalStatusSpeech_Underproductive" name="cbMentalStatusSpeech_Underproductive" className='add-only' value="MentalStatusSpeech_Underproductive" /> Underproductive


                    <textarea id="txtMentalStatusSpeech" name="txtMentalStatusSpeech" className='add-only' ></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Insight / Judgment?</span>


                    <input type="checkbox" id="cbMentalStatusInsight_Poor" name="cbMentalStatusInsight_Poor" className='add-only' value="MentalStatusInsight_Poor" /> Poor &nbsp;
                    <input type="checkbox" id="cbMentalStatusInsight_Fair" name="cbMentalStatusInsight_Fair" className='add-only' value="MentalStatusInsight_Fair" /> Fair &nbsp;
                    <input type="checkbox" id="cbMentalStatusInsight_Good" name="cbMentalStatusInsight_Good" className='add-only' value="MentalStatusInsight_Good" /> Good &nbsp;
                    <input type="checkbox" id="cbMentalStatusInsight_Excellent" name="cbMentalStatusInsight_Excellent" className='add-only' value="MentalStatusInsight_Excellent" /> Excellent

                    <textarea id="txtMentalStatusInsight" name="txtMentalStatusInsight" className='add-only' ></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Alertness / Orientation?</span>


                    <input type="checkbox" id="cbMentalStatusAlertness_Alert" name="cbMentalStatusAlertness_Alert" className='add-only' value="MentalStatusAlertness_Alert" /> Alert &nbsp;
                    <input type="checkbox" id="cbMentalStatusAlertness_NonAlert" name="cbMentalStatusAlertness_NonAlert" className='add-only' value="MentalStatusAlertness_NonAlert" /> Non-Alert &nbsp;
                    <input type="checkbox" id="cbMentalStatusAlertness_Person" name="cbMentalStatusAlertness_Person" className='add-only' value="MentalStatusAlertness_Person" /> Person &nbsp;
                    <input type="checkbox" id="cbMentalStatusAlertness_Place" name="cbMentalStatusAlertness_Place" className='add-only' value="MentalStatusAlertness_Place" /> Place &nbsp;
                    <input type="checkbox" id="cbMentalStatusAlertness_Time" name="cbMentalStatusAlertness_Time" className='add-only' value="MentalStatusAlertness_Time" /> Time &nbsp;
                    <input type="checkbox" id="cbMentalStatusAlertness_Situation" name="cbMentalStatusAlertness_Situation" className='add-only' value="MentalStatusAlertness_Situation" /> Situation

                    <textarea id="txtMentalStatusAlertness" name="txtMentalStatusAlertness" className='add-only' ></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Memory?</span>


                    <input type="checkbox" id="cbMentalStatusMemory_Intact" name="cbMentalStatusMemory_Intact" className='add-only' value="MentalStatusMemory_Intact" /> Intact &nbsp;
                    <input type="checkbox" id="cbMentalStatusMemory_NonIntact" name="cbMentalStatusMemory_NonIntact" className='add-only' value="MentalStatusMemory_NonIntact" /> Non Intact &nbsp;
                    <input type="checkbox" id="cbMentalStatusMemory_Immediate" name="cbMentalStatusMemory_Immediate" className='add-only' value="MentalStatusMemory_Immediate" /> Immediate &nbsp;
                    <input type="checkbox" id="cbMentalStatusMemory_Recent" name="cbMentalStatusMemory_Recent" className='add-only' value="MentalStatusMemory_Recent" /> Recent &nbsp;
                    <input type="checkbox" id="cbMentalStatusMemory_Remote" name="cbMentalStatusMemory_Remote" className='add-only' value="MentalStatusMemory_Remote" /> Remote Recall

                    <textarea id="txtMentalStatusMemory" name="txtMentalStatusMemory" className='add-only' ></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Intelligence?</span>


                    <input type="checkbox" id="cbMentalStatusIntelligence_MildDisabilities" name="cbMentalStatusIntelligence_MildDisabilities" className='add-only' value="MentalStatusIntelligence_MildDisabilities" /> Mild Disabilities &nbsp;
                    <input type="checkbox" id="cbMentalStatusIntelligence_Borderline" name="cbMentalStatusIntelligence_Borderline" className='add-only' value="MentalStatusIntelligence_Borderline" /> Borderline Intellectual Functioning &nbsp;
                    <input type="checkbox" id="cbMentalStatusIntelligence_Average" name="cbMentalStatusIntelligence_Average" className='add-only' value="MentalStatusIntelligence_Average" /> Average &nbsp;
                    <input type="checkbox" id="cbMentalStatusIntelligence_AboveAverage" name="cbMentalStatusIntelligence_AboveAverage" className='add-only' value="MentalStatusIntelligence_AboveAverage" /> Above Average &nbsp;
                    <textarea id="txtMentalStatusIntelligence" name="txtMentalStatusIntelligence" className='add-only' ></textarea>
                </p>






                <p>
                    <span className='eleHeader'>Treatment Recommendations:</span>
                    Continue counseling, Reviewed medication history, Desired treatment effects, Potential side effects, Risk and benefits of treatment, Answered questions and obtained informed consent for treatment and any medication ordered. Patient and family were advised to seek Emergency treatment if Psychiatric condition deteriorates with any worsening of SI, HI or Psychosis.
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTreatmentRecommendations_1" name="cbTreatmentRecommendations_1" className='add-only' value="TreatmentRecommendations_1" /> Increase structure and consistent routine </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTreatmentRecommendations_2" name="cbTreatmentRecommendations_2" className='add-only' value="TreatmentRecommendations_2" /> No Alcohol or Drugs </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTreatmentRecommendations_3" name="cbTreatmentRecommendations_3" className='add-only' value="TreatmentRecommendations_3" /> Follow up with Primary Care MD for Medical Issues</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTreatmentRecommendations_4" name="cbTreatmentRecommendations_4" className='add-only' value="TreatmentRecommendations_4" /> Decrease calorie intake and increase routine exercise to help with Weight Loss </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTreatmentRecommendations_5" name="cbTreatmentRecommendations_5" className='add-only' value="TreatmentRecommendations_5" /> Increase calorie intake to increase weight </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTreatmentRecommendations_6" name="cbTreatmentRecommendations_6" className='add-only' value="TreatmentRecommendations_6" /> Improve routine sleep habits / eliminate naps during the daytime </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTreatmentRecommendations_7" name="cbTreatmentRecommendations_7" className='add-only' value="TreatmentRecommendations_7" /> Improve compliance on medication using Pill Planner </td>
                    </tr>
                </table>
                <p>
                    <textarea id="txtTreatmentRecommendations" name="txtTreatmentRecommendations" className='add-only' ></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Return to clinic for Follow-up Psychiatric appointment:</span>
                    <input type="checkbox" id="cbAppointment_1" name="cbAppointment_1" className='add-only' value="Appointment_1" /> 4 Weeks &nbsp;
                    <input type="checkbox" id="cbAppointment_2" name="cbAppointment_2" className='add-only' value="Appointment_2" />  6 Weeks &nbsp;
                    <input type="checkbox" id="cbAppointment_3" name="cbAppointment_3" className='add-only' value="Appointment_3" />  8 Weeks &nbsp;
                    <input type="checkbox" id="cbAppointment_4" name="cbAppointment_4" className='add-only' value="Appointment_4" />  12 Weeks &nbsp;
                    <input type="checkbox" id="cbAppointment_5" name="cbAppointment_5" className='add-only' value="Appointment_5" />  16 Weeks &nbsp;
                    <input type="checkbox" id="cbAppointment_6" name="cbAppointment_6" className='add-only' value="Appointment_6" />  Weeks
                </p>

                <p>
                    <span className='eleHeader'>Check Labs:</span>
                    <input type="checkbox" id="cbCheckLabs_1" name="cbCheckLabs_1" className='add-only' value="CheckLabs_1" /> CMP &nbsp;
                    <input type="checkbox" id="cbCheckLabs_2" name="cbCheckLabs_2" className='add-only' value="CheckLabs_2" />  CBC w/Diff &nbsp;
                    <input type="checkbox" id="cbCheckLabs_3" name="cbCheckLabs_3" className='add-only' value="CheckLabs_3" />  TSH, T3, Free T4 &nbsp;
                    <input type="checkbox" id="cbCheckLabs_4" name="cbCheckLabs_4" className='add-only' value="CheckLabs_4" />  Lipid panel &nbsp;
                    <input type="checkbox" id="cbCheckLabs_5" name="cbCheckLabs_5" className='add-only' value="CheckLabs_5" />  HgbA1c &nbsp;
                    <input type="checkbox" id="cbCheckLabs_6" name="cbCheckLabs_6" className='add-only' value="CheckLabs_6" />  UA &nbsp;
                    <input type="checkbox" id="cbCheckLabs_7" name="cbCheckLabs_7" className='add-only' value="CheckLabs_7" />  UDS
                </p>


                <p>
                    <span className='eleHeader'>Level:</span>

                    <input type="text" id="txtLevel" name="txtLevel" className='add-only' /> 
                </p>


                <p>
                    <span className='eleHeader'>Physician Orders:</span>
                    <span className='small'>(See prescription printout and continue current medications except...)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-20'>1.</td>
                        <td className='w-730'>
                            <input type="text" id="txtPhysicianOrders_1" name="txtPhysicianOrders_1" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>2.</td>
                        <td className='w-730'>
                            <input type="text" id="txtPhysicianOrders_2" name="txtPhysicianOrders_2" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>3.</td>
                        <td className='w-730'>
                            <input type="text" id="txtPhysicianOrders_3" name="txtPhysicianOrders_3" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>4.</td>
                        <td className='w-730'>
                            <input type="text" id="txtPhysicianOrders_4" name="txtPhysicianOrders_4" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>5.</td>
                        <td className='w-730'>
                            <input type="text" id="txtPhysicianOrders_5" name="txtPhysicianOrders_5" className='add-only' /> </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className="small w-500">Physician Signature:</td>
                        <td className="small w-250">Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className="small w-750">Physician Name(Printed):</td>
                    </tr>
                </table>





            </div>
        </form>

    )
}  
